import React, {useContext, useEffect, useState} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {Box, CircularProgress, Snackbar} from "@mui/material";
import {
    BrowserRouter as Router,
    Routes,
    Route,
    useNavigate, useLocation
} from "react-router-dom";
import axios from "axios";
import Alert from "@mui/material/Alert";
import Download from './components/Download';
import HomePage from "./components/HomePage";
import PartnersPage from "./components/PartnersPage";
import { Document, Page } from 'react-pdf';
import consent from './files/04_consent.pdf';
import policy from './files/05_policy.pdf';
import pep from './files/07_pep.pdf'
import offer from './files/01_offer.pdf';
import offerSpecialist from './files/02_offer_specialist.pdf';
import priceList from './files/08_price_list.pdf';
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import {range} from "./utils/listUtils";

export const AuthContext = React.createContext(null);



const AuthProvider = ({ children }) => {

    const EMPTY_USER = {
        id: "",
        userName: "",
        token: "",
        credits: 0,
    };

    const navigate = useNavigate();

    const [ user, setUser ] = useState(EMPTY_USER)
    const [ notification, setNotification ] = useState({
        isOpen: false,
        severity: "success",
        text: ""
    })

    return (
        <AuthContext.Provider value={{}}>
            { notification.isOpen ?
                <>
                    <Snackbar
                        open={notification.isOpen}
                        autoHideDuration={6000}
                        onClose={() => { setNotification(prevState => ({...prevState, isOpen: false}))}}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right'
                        }}
                    >
                        <Alert onClose={() => { setNotification(prevState => ({...prevState, isOpen: false}))}} severity={notification.severity} sx={{ width: '100%' }}>
                            { notification.text }
                        </Alert>
                    </Snackbar>
                </>
                : null
            }
            {children}
        </AuthContext.Provider>
    );
};

// const Route

pdfjs.GlobalWorkerOptions.workerSrc = 'https://unpkg.com/pdfjs-dist@' + pdfjs.version + '/build/pdf.worker.min.mjs';
// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//     'pdfjs-dist/build/pdf.worker.min.mjs',
//     import.meta.url,
// ).toString();

const root = ReactDOM.createRoot(document.getElementById('root'));
const PDF_DOCUMENT_WIDTH = 1200;
root.render(
    <React.StrictMode>
            <Router>
                <AuthProvider>
                    <Routes>
                        <Route path={'/'}
                               element={
                                   <HomePage />
                               }
                        />
                        <Route path={'/partners'}
                               element={
                                   <PartnersPage />
                               }
                        />
                        {

                            [
                                {link: '/consent', file: consent, numPages: 3},
                                {link: '/policy', file: policy, numPages: 4},
                                {link: '/pep', file: pep, numPages: 3},
                                {link: '/offer', file: offer, numPages: 5},
                                {link: '/offer-specialist', file: offerSpecialist, numPages: 4},
                                {link: '/pricing', file: priceList, numPages: 1},
                            ].map(it => (
                                <Route path={it.link}
                                       element={
                                            <Download file={it.file}/>
                                           // <Box>
                                           //     <div style={{ maxWidth: '1200px', margin: '0 auto', maxHeight: '1025px', marginBottom: '20px' }}>
                                           //         <Document
                                           //             file={it.file}
                                           //         >
                                           //             {
                                           //                 range(1, it.numPages + 1,1).map(pageNum => {
                                           //                     return <Page pageNumber={pageNum} width={PDF_DOCUMENT_WIDTH}/>
                                           //                 })
                                           //             }
                                           //         </Document>
                                           //     </div>
                                           // </Box>
                                       }
                                />
                            ))
                        }
                    </Routes>
                </AuthProvider>
            </Router>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
